import { viewportSize } from '../editor.ts'
import { nodesBounds } from '../scene/geometry.ts'
import { orderedNodes, scene, selectedNodes, setCamera } from '../scene/store.ts'
import { clampZoom, fitRect, zoomAt } from './camera.ts'
import type { Rect } from '../scene/types.ts'

export function zoomBy(factor: number): void {
  const { w, h } = viewportSize()
  setCamera(zoomAt(scene.camera, { x: w / 2, y: h / 2 }, factor))
}

export function setZoom(z: number): void {
  const { w, h } = viewportSize()
  setCamera(zoomAt(scene.camera, { x: w / 2, y: h / 2 }, clampZoom(z) / scene.camera.z))
}

function fit(rect: Rect | null): void {
  const { w, h } = viewportSize()
  if (!rect || w === 0 || h === 0) return
  setCamera(fitRect(rect, w, h))
}

export function zoomToFit(): void {
  fit(nodesBounds(orderedNodes().filter((n) => !n.hidden)))
}

export function zoomToSelection(): void {
  fit(nodesBounds(selectedNodes()))
}

/** Reset to 1:1, keeping the viewport center on the same world point. */
export function resetZoom(): void {
  setZoom(1)
}
